(function ($) {
	const isLoginPage = $("body").hasClass("login-page");
	if (!isLoginPage) return false;
	

	const elms = {
		submit: ".js-submit-login",
	};

	const goToLogin = function (e) {
		e.preventDefault();

		const loginAsGuest = () => {
			return bdapi.post("public/create-guest-user").then((response) => {
				if (!response.data.success) {
					bdjs.hideLoading();
					alert(response.data.message);
					return;
				}

				const data = response.data.data;

				if (data.redirect) {
					window.location.href = data.redirect + BD_Helper.suffixURL()
				}
			});
		};

		const loginMode = $(this).attr("data-login-mode");
		const loginUrl = $(this).attr("data-login-url");

		const isLoginModeNone = loginMode == null || loginMode == "none";

		if (loginMode == 'none' || loginMode == '') {
			bdjs.showLoading(loginAsGuest);
		} else {
			// TODO implement custom login mode and SSO login mode
			window.location.href = loginUrl;
		}
	};

	$(elms.submit).on("click", goToLogin);
	bdjs.hideLoading();
})(jQuery);
